import { Base } from "../../framework/base";
import { ListItems } from "../../framework/listItems";
import { AppReportTemplateListItem, IAppReportTemplateListItem } from "./appReportTemplateListItem";

export interface IAppReportTemplateListItems extends ListItems<IAppReportTemplateListItem> {
}

export class AppReportTemplateListItems extends ListItems<AppReportTemplateListItem> implements IAppReportTemplateListItems {
    constructor();
    constructor(obj: IAppReportTemplateListItems);
    constructor(obj?: any) {
        super(obj);
        this.items = Base.getTypedArray(obj ? obj.items : null, AppReportTemplateListItem);
    }
}